export const DuplicateProjectWarning = ({ name, projects, excludeId, testId = 'duplicate-project-warning' }) => {
  const matches = projects.filter((p) => p.id !== excludeId && name.trim() && p.name.trim().toLowerCase() === name.trim().toLowerCase());
  if (!matches.length) return null;
  return (
    <p role="status" data-testid={testId} className="mt-2 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-3 break-words">
      A project with this name already exists: {matches.map((p) => p.id).join(', ')}. You can still create a separate project with its own PRJ code.
    </p>
  );
};